<template>
  <div class="top-positions">
    <bim-text type=main>Топ позиций:</bim-text>
    <ol class="top-positions__ol">
      <li
        v-for="position of topPositions"
        :key="position"
        class="top-positions__li"
      >
        <bim-text type=main>{{ position }}</bim-text>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  props: {
    name: "BlockTopPositions",
    positions: Object,
  },
  computed: {
    topPositions() {
      return this.positions.positions.slice(0, 3)
    }
  }
}
</script>

<style lang="scss" scoped>
.top-positions {
  max-width: 683px;

  .top-positions__ol {
    padding: 0 16px;
    list-style-type: decimal;
  }
}
</style>
